








import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyCheckAmountKey from "@/components/company-check-amout-key";
import CheckAmountInput from '../../components/templates/CheckAmount/CheckAmountInput.vue'
import TableCheckAmount from '../../components/templates/CheckAmount/TableCheckAmount.vue'
import Loading from '../../components/molecules/Loading.vue'
export default createComponent( {
   setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyCheckAmount = inject(CompanyCheckAmountKey);
    if (!companyCheckAmount) {
      throw new Error(`${CompanyCheckAmountKey} is not provided`);
    }
    const loading = computed(() => companyCheckAmount.loading)
    
    return {
      loading,
    };
  },

  components: {
    CheckAmountInput,
    TableCheckAmount,
    Loading
  },
});
